export const CORE_QUESTIONS = [
  {
    id: "q1",
    text: "What is my absolute go-to midnight snack?",
    options: ["Pizza rolls/Leftovers", "Something sweet (Ice cream/Chocolate)", "Salty chips & dip", "Just water, I'm boring"],
  },
  {
    id: "q2",
    text: "If I have a free weekend, where am I most likely?",
    options: ["Out with friends/Partying", "Rotting in bed with TikTok/Netflix", "Playing video games for 10 hours", "Doing something productive/Outdoors"],
  },
  {
    id: "q3",
    text: "How do I handle conflict?",
    options: ["Avoid it at all costs", "Face it head-on immediately", "Overthink it for 3 days first", "Make a joke to deflect"],
  },
  {
    id: "q4",
    text: "What gaming genre do I actually spend the most time on?",
    options: ["Cozy/Farming simulators", "Competitive FPS/MOBAs", "Story-rich RPGs", "I don't really game"],
  },
  {
    id: "q5",
    text: "If I won $1 Million right now, what's my first purchase?",
    options: ["A crazy vacation", "Paying off debt/Investing safely", "A ridiculous luxury item", "Buying something for my family/friends"],
  },
  {
    id: "q6",
    text: "How many alarms do I set in the morning?",
    options: ["Just one, and I'm up", "2-3, standard stuff", "5+, and I still sleep through them", "None, my internal clock wakes me"],
  },
  {
    id: "q7",
    text: "What's my biggest pet peeve?",
    options: ["Loud chewers", "Slow walkers", "Being interrupted", "People being late"],
  },
  {
    id: "q8",
    text: "My ideal pet situation is:",
    options: ["Dogs all the way", "Cats rule", "A weird exotic pet (reptile/bird)", "No pets, too much responsibility"],
  },
  {
    id: "q9",
    text: "How do I usually text?",
    options: ["Perfect grammar and punctuation.", "keysmashing and all lowercase", "Voice notes mostly", "One. Word. Answers."],
  },
  {
    id: "q10",
    text: "If I were a movie character, what would my role be?",
    options: ["The heroic main character", "The comic relief best friend", "The mysterious villain", "The one who dies first"],
  }
];

export const VIBES = [
  {
    id: 0,
    title: "The Chaos Gremlin",
    desc: "Unpredictable, slightly unhinged, but always a good time.",
    color: "from-[#d2ff02] to-[#329503]"
  },
  {
    id: 1,
    title: "The Chill Observer",
    desc: "Low energy, high awareness. You just vibe.",
    color: "from-[#0094f7] to-[#012b58]"
  },
  {
    id: 2,
    title: "The Strategic Mastermind",
    desc: "Always plotting, always overthinking.",
    color: "from-[#329503] to-[#0094f7]"
  },
  {
    id: 3,
    title: "The Wholesome Bean",
    desc: "Pure intentions, probably needs a nap.",
    color: "from-[#d2ff02] to-[#0094f7]"
  },
];